import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 5l0 14","key":"svg-0"}],["path",{"d":"M14 5l0 14","key":"svg-1"}]]

const IconTallymark2 = createReactComponent('outline', 'tallymark-2', 'Tallymark2', __iconNode);

export default IconTallymark2;